import { Card, Group, Progress, SimpleGrid, Stack, Text } from "@mantine/core";
import { formatLimit, type Me } from "../lib/api";
import { useSpecs } from "../lib/hooks";

function Meter({ label, used, limit, text }: { label: string; used: number; limit: number; text: string }) {
  const pct = limit > 0 ? Math.min(100, (used / limit) * 100) : 100;
  return (
    <Stack gap={4}>
      <Group justify="space-between" wrap="nowrap">
        <Text size="sm">{label}</Text>
        <Text size="sm" c="dimmed">{text}</Text>
      </Group>
      <Progress value={pct} color={pct >= 90 ? "red" : pct >= 70 ? "orange" : "blue"} aria-label={label} />
    </Stack>
  );
}

export function UsageMeters({ me }: { me: Me }) {
  const specs = useSpecs();
  const L = me.limits, U = me.usage;
  const n = (k: string) => Number(L[k] ?? 0);
  return (
    <Card withBorder>
      <Text fw={600} mb="sm">Usage</Text>
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="lg">
        <Meter label="Storage" used={U.storage_mb} limit={n("storage.max_total_mb")}
          text={`${U.storage_mb.toFixed(1)} MB of ${formatLimit(specs["storage.max_total_mb"], L["storage.max_total_mb"])}`} />
        <Meter label="Compute this month" used={U.cpu_hours_month} limit={n("platform.cpu_hours_per_month")}
          text={`${U.cpu_hours_month.toFixed(2)} of ${L["platform.cpu_hours_per_month"]} CPU-h`} />
        <Meter label="Projects" used={U.projects} limit={n("storage.max_projects")} text={`${U.projects} of ${L["storage.max_projects"]}`} />
        <Meter label="Files" used={U.files} limit={n("storage.max_files")} text={`${U.files} of ${L["storage.max_files"]}`} />
        <Meter label="Jobs today" used={U.jobs_today} limit={n("platform.max_jobs_per_day")} text={`${U.jobs_today} of ${L["platform.max_jobs_per_day"]}`} />
        <Meter label="Running now" used={U.jobs_active} limit={n("platform.max_concurrent_jobs")} text={`${U.jobs_active} of ${L["platform.max_concurrent_jobs"]}`} />
      </SimpleGrid>
    </Card>
  );
}
